import { lazy, Suspense } from "react";
import { createFileRoute, notFound } from "@tanstack/react-router";

import { useProject, useProjectId } from "../../shell/project";
import { agentWorkspaceEnabled } from "../../workspaces/agents/availability";

const TeamPage = lazy(() => import("../../workspaces/agents/beside/TeamPage"));

export const Route = createFileRoute("/_console/p/$org/$project/loop/team")({
  beforeLoad: () => {
    if (!agentWorkspaceEnabled) throw notFound();
  },
  component: TeamRoute,
});

/** The team as a page of its own: every agent, the ones that need someone first. */
function TeamRoute() {
  const projectId = useProjectId();
  const { address } = useProject();
  if (!address) return null;
  return (
    <Suspense fallback={null}>
      <TeamPage projectId={projectId} address={address} />
    </Suspense>
  );
}
